import { useState } from 'react'
import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import { returnBlockValue } from '@/utils/op-types/helperFunctions'

import Card from '@/components/optypes/frontend/SideScroller/blocks/Card'
import Input from '@/components/optypes/headlesss-components/Input'
// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

const HeaderBlock = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  const [autoFocus, setAutoFocus] = useState(false)

  return (
    <Card className="opr-inputblock">
      <div className="opr-card-header">
        <h2 className="text-lg font-bold">
          {returnBlockValue('title', 'content', opBlocks[block], content)}
        </h2>

        <h3 className="text-sm">
          {returnBlockValue('desc', 'content', opBlocks[block], content)}
        </h3>
      </div>

      <div className="opr-card-content mt-4">
        <Input
          className="rounded placeholder-current placeholder-opacity-50 py-0 px-0 text-xl border-transparent focus:outline-none focus:ring-2 focus:ring-transparent focus:border-transparent"
          blockId={id}
          contentKey="value"
          placeholder={returnBlockValue(
            'placeholder',
            'content',
            opBlocks[block],
            content
          )}
          onEnter={() => {}}
          // autoFocus={autoFocus}
        />
        {returnBlockValue('context', 'content', opBlocks[block], content) && (
          <div className="text-xs mt-4 opacity-50">
            {returnBlockValue('context', 'content', opBlocks[block], content)}
          </div>
        )}
      </div>
    </Card>
  )
}

export default HeaderBlock
